/**
 * Lê uma chave do payload do backend, tolerando os dois shapes em uso:
 *   - envelope: { status, message, data: { <key>: ... } }   (BaseController.ok)
 *   - direto:   { <key>: ... }                              (jsonResponse cru)
 *
 * Existe porque o `backend-senne` mistura os dois — `csrf.controller` envelopa,
 * `refresh-token.controller` retorna direto. Centralizar aqui evita o bug que
 * gerou 403 em /auth/refresh quando o frontend lia `response.data.csrfToken`
 * direto e o controller usava o envelope.
 */
export function unwrapField<T = unknown>(
  responseData: unknown,
  key: string,
): T | undefined {
  if (!responseData || typeof responseData !== "object") return undefined;
  const root = responseData as Record<string, unknown>;
  const enveloped = root.data as Record<string, unknown> | undefined;
  if (enveloped && typeof enveloped === "object" && key in enveloped) {
    return enveloped[key] as T;
  }
  if (key in root) return root[key] as T;
  return undefined;
}
